import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
const bonuses = [{
  title: 'Guía de Herramientas Esenciales',
  desc: 'Descubre exactamente qué herramientas necesitas para empezar sin gastar una fortuna en equipo innecesario.',
  value: '12.990',
  image: 'https://cdn.magicpatterns.com/uploads/iB4CzAixLScw87KMuFmw75/B1.webp'
}, {
  title: 'Selección y Tipos de Cuero',
  desc: 'Aprende a identificar, comprar y utilizar el cuero correcto para cada tipo de proyecto y evita errores costosos.',
  value: '9.990',
  image: 'https://cdn.magicpatterns.com/uploads/4MCegSfYdwUjefPEswN2t1/B2.webp'
}, {
  title: 'Técnicas de Costura Profesional',
  desc: 'Domina la costura a dos agujas (saddle stitch) y logra puntadas perfectas que durarán toda la vida.',
  value: '14.990',
  image: 'https://cdn.magicpatterns.com/uploads/4RTk79ZoxuBuN9ThU2SMB2/B3.webp'
}, {
  title: 'Secretos de Acabados y Bordes',
  desc: 'El secreto de un artículo premium está en los bordes. Aprende a bruñir y pintar bordes como las marcas de lujo.',
  value: '12.990',
  image: 'https://cdn.magicpatterns.com/uploads/jES7e678PFDhnVnbD59zXL/B4.webp'
}, {
  title: 'Plantillas de Personalización',
  desc: 'Añade iniciales, logos y detalles únicos a tus creaciones con esta guía de personalización avanzada.',
  value: '8.990',
  image: 'https://cdn.magicpatterns.com/uploads/oqj5wUb8MEfpX9Tu5ugQaF/B5.webp'
}, {
  title: 'Guía de Precios para Artesanos',
  desc: 'Cómo calcular el costo de tus materiales y tiempo para vender tus creaciones de cuero con ganancias reales.',
  value: '14.990',
  image: 'https://cdn.magicpatterns.com/uploads/ctjaeBzeP5Zy4g24afxzzR/B6.webp'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      type: 'spring',
      stiffness: 100,
      damping: 15
    }
  }
};
export function BonusSection() {
  return <section className="bg-gradient-to-b from-leather-dark to-[#2A180E] py-24 px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-47">
      {/* Subtle gold texture overlay */}
      <div className="absolute inset-0 opacity-10 pointer-events-none" style={{
      backgroundImage: 'url("https://www.transparenttextures.com/patterns/stardust.png")'
    }} data-id="element-48"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-49">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        type: 'spring',
        stiffness: 100,
        damping: 15
      }} className="text-center mb-16" data-id="element-50">
          <div className="inline-flex items-center justify-center gap-2 bg-gold/20 border border-gold/50 text-gold px-6 py-2 rounded-full font-bold mb-6 shadow-[0_0_15px_rgba(201,168,76,0.3)]" data-id="element-51">
            <Gift className="w-5 h-5" data-id="element-52" />
            <span className="tracking-widest uppercase text-sm" data-id="element-53">
              Bonos Incluidos Gratis
            </span>
          </div>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-cream mb-6" data-id="element-54">
            Lleva Tu Técnica al Siguiente Nivel
          </h2>
          <p className="text-xl text-cream/80 max-w-2xl mx-auto" data-id="element-55">
            Al acceder hoy, también recibes estos 6 eBooks técnicos sin costo
            adicional.
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} className="space-y-8" data-id="element-56">
          {bonuses.map((bonus, index) => <motion.div key={index} variants={itemVariants} whileHover={{
          scale: 1.02
        }} className="flex flex-col sm:flex-row gap-0 sm:gap-8 p-1 rounded-2xl bg-gradient-to-r from-gold/40 via-gold/10 to-transparent relative overflow-hidden group" data-id="element-57">
              <div className="bg-[#1A1A1A] rounded-xl w-full flex flex-col sm:flex-row overflow-hidden border border-gold/20 shadow-2xl" data-id="element-58">
                <div className="relative w-full sm:w-80 flex-shrink-0 overflow-hidden" data-id="element-59">
                  <div className="absolute top-4 left-4 z-20 bg-gold text-darktext font-black text-sm px-3 py-1 rounded-md shadow-lg uppercase tracking-wider" data-id="element-60">
                    Bono {index + 1}
                  </div>
                  <img src={bonus.image} alt={bonus.title} className="w-full h-auto group-hover:scale-110 transition-transform duration-700 ease-out" data-id="element-61" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent sm:hidden" data-id="element-62"></div>
                </div>
                <div className="flex flex-col justify-center flex-grow p-6 sm:p-8" data-id="element-63">
                  <h3 className="font-heading text-2xl sm:text-3xl font-bold text-gold mb-4" data-id="element-64">
                    {bonus.title}
                  </h3>
                  <p className="text-cream/80 mb-6 leading-relaxed text-lg" data-id="element-65">
                    {bonus.desc}
                  </p>
                  <div className="mt-auto flex items-center" data-id="element-66">
                    <span className="text-cream/50 line-through mr-3 text-lg" data-id="element-67">
                      Valor: ${bonus.value}
                    </span>
                    <span className="text-green-400 font-bold text-lg bg-green-400/10 px-3 py-1 rounded-md" data-id="element-68">
                      (GRATIS HOY)
                    </span>
                  </div>
                </div>
              </div>
            </motion.div>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        type: 'spring',
        stiffness: 100,
        damping: 15,
        delay: 0.4
      }} className="mt-16 relative" data-id="element-69">
          <motion.div animate={{
          boxShadow: ['0px 0px 20px rgba(201,168,76,0.2)', '0px 0px 50px rgba(201,168,76,0.6)', '0px 0px 20px rgba(201,168,76,0.2)']
        }} transition={{
          duration: 3,
          repeat: Infinity
        }} className="bg-gradient-to-br from-gold/20 to-transparent border border-gold p-10 rounded-3xl text-center shadow-2xl backdrop-blur-sm" data-id="element-70">
            <p className="text-2xl text-cream/90 mb-3 font-medium" data-id="element-71">
              Valor Total de los Bonos:
            </p>
            <p className="text-4xl font-bold text-cream/40 line-through mb-4" data-id="element-72">
              $74.940
            </p>
            <p className="font-heading text-5xl md:text-6xl font-black text-gold drop-shadow-[0_2px_10px_rgba(0,0,0,0.5)]" data-id="element-73">
              ¡GRATIS CON TU COMPRA HOY!
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}